import { render, staticRenderFns } from "./MailboxIcon.vue?vue&type=template&id=17644eca"
import script from "./MailboxIcon.vue?vue&type=script&lang=js"
export * from "./MailboxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports